{
	"povzetek": {
		"title": "Povzetek",
		"skupno30": "Zadnjih 30 dni",
		"skupno90": "Zadnjih 90 dni",
		"skupno365": "Zadnjih 365 dni",
		"vsiO": "Vsi opravljeni leti",
		"povprecje": "Povprečna dolžina leta",
		"najveckratV": "Največkrat leteno letalo"
	},
	"povzetekLabel": {
		"dan": "Dnevno",
		"slepo": "Slepo"
	},
	"table": {
		"datum": "Datum",
		"letalisce":"Letališče",
		"trajanje":"Trajanje",
		"vzlet":"Vzlet",
		"diaryTitle": "Dnevniški zapisi"
	},
	"modal": {
		"datum": "Datum:",
		"odhodCas": "Čas odhoda:",
		"kilometri": "Preleteni kilometri:",
		"trajanjeDan": "Trajanje leta (dan):",
		"trajanjeSlepo": "Trajanje leta (slepo):",
		"stLetov": "Število letov:",
		"odhod":"Odhod:",
		"krajO":"Kraj odhoda:",
		"nacinStarta": "Način štarta:",
		"zrakoplov":"Zrakoplov:",
		"reg":"Registracija: ",
		"vodjaZ":"Ime vodje zrakoplova:",
		"opomba":"Opomba:"
	},
	"labelsLJ": {
		"casO":"Čas odhoda:",
		"casP":"Čas prihoda:",
		"model":"Model zrakoplova:",
		"reg":"Registracija zrakoplova:",
		"vodjaZ":"Ime vodje zrakoplova:",
		"posadka": "Enočlanska / Veččlanska posadka :",
		"pogoji":"Pogoji letenja:",
		"pD":"Dan",
		"pN":"Slepo",
		"stPristankov":"Št. pristankov:",
		"ttof":" Ttof:",
		"op":"Način letenja :",
		"opD":"Dnevno",
		"opN":"Slepo",
		"vp":"Vloga pilota:",
		"fstd":"Čas FSTD:",
		"opomba":"Opomba:",
		"pristanek": "Izberi pristanek :",
		"regL": "Izberi reg. jadralnega letala :",
		"nacinStarta": "Način starta :"
	},
	"optionsLJ": {
		"aerozaprega": "Aerozaprega",
		"vitla": "Vitla"
	},
	"buttons": {
		"urediPodatke":"Uredi podatke",
		"posodobiPodatke":"Posodobi podatke",
		"brisiZapis":"Izbriši zapis",
		"brisiIzbiro":"Pobriši izbiro",
		"natisni": "Natisni",
		"poslji": "Pošlji"
	}
}